import containerFuild from '../html-snippets/container-fuild';
import css from '../css-snippets/section-card-banner-gatorz';

const html = `
<div class="wrap-card">
  <div
    data-attribute="card-image"
    class="wrap-image"
    data-show-overlay="true"
    data-overlay-opacity="0.2"
    style="--overlay-opacity: 0.2"
  >
    <img
      data-attribute="card-image-src"
      src="https://cdn.skyfastimg.com/images/2026/06/11/image-6a2a1f76a3fb234b712371ab.webp"
      alt="Image"
    />
  </div>
  <div class="content-container">
    <div class="container-gatorz">
      <div
        data-show="true"
        data-position="left"
        data-max-width="1920"
        data-attribute="card-content"
        class="content-card"
        style="--ct-max-width: 1920px"
      >
        <h2>WARHAWK</h2>
        <p>Your Vision, Our Mission</p>
      </div>
    </div>
  </div>
</div>
`;

export default containerFuild(html, css, {
  textColor: '#FFFFFF',
});
